import API, {Services} from '../../../../adapters/rest';
import {injectParamsIntoUrl} from '../../../../shared/utils';

export const getWorkOrderReportById = (
    projectId: string,
    workOrderId: string
): Promise<any> => {
    const url = injectParamsIntoUrl(
        `/${Services.THINGS}/v1/projects/:projectId/workOrders/:workOrderId/report`,
        {
            projectId,
            workOrderId,
        }
    );

    return API.get(url).then((response) => response.data);
};
